/* eslint-disable no-underscore-dangle */

'use strict';

define('vb/private/stateManagement/router/urlAdapter',[
  'vb/private/stateManagement/router/stateChange',
  'vb/private/stateManagement/router/vbRouter',
], (StateChange, VbRouter) => {
  /**
   * @typedef {import('vb/private/stateManagement/router/vbRootRouter').default} VbRootRouter
   */

  /**
   * Base class for all the URL adapter.
   */
  class UrlAdapter {
    /**
     * @param {string} baseUrlProp
     */
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    init(baseUrlProp) {
    }

    /**
     * Construct an array of states where each item is an object made of a router and
     * the new state for it.
     * @param {Object} transition An object with properties describing the transition.
     * @return {!Array.<StateChange>}
     * @throws Error when parsing of router param fails.
     */
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    parse(transition) {
      return [];
    }

    /**
     * @param {StateChange[]} newStates
     * @returns {string}
     */
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    buildUrlFromStates(newStates) {
      return '';
    }

    /**
     * @param {VbRootRouter} rootRouter
     * @param {Array<string>} segments
     */
    static getChangesFromSegments(rootRouter, segments) {
      let changes = [];
      /** @type {VbRouter} */
      let router = rootRouter;

      while (router) {
        const value = segments.shift();
        if (!value) {
          break;
        }

        const stateChange = new StateChange(router, value);

        const state = stateChange.getState();

        // If this state has parameters, the following segments are parameter values
        if (state) {
          state._paramOrder.forEach(() => {
            // Retrieve the next segment and use it for the parameter value
            stateChange.addParameter(segments.shift());
          });
        }

        changes.push(stateChange);
        router = router._getChildRouter(value);
      }

      changes = VbRouter.appendOtherChanges(changes, rootRouter);

      return changes;
    }
  }

  return UrlAdapter;
});

